<template>
    <layout>
        <span slot="header">{{ title }}
            <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
            <i class="fas fa-print" style="font-size: 22px !important; float: right; margin-right: 70px;" @click="tagPrint"></i>
        </span>
        <div slot="content">
            <div id="printf" class="page">
                <div class="talbe-contain">
                    <div class="inner-box" style="margin-top: 18px;">
                        <div class="table-area" v-for="(data, idx) in items" :key="idx" style="width: 49%; display: flex; float: left;">
                            <div class="table-b">
                                <table style="width: 100%; height: 90%;">
                                    <tr>
                                        <td style="text-align: center; font-size: 11px;">
                                            자재 반납 TAG
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <table border="1" cellpadding="0" cellspacing="0" bordercolor="#333333" bgcolor="#333333" class="font-big" style="width: 100%;">
                                                <tr style="background-color: white;">
                                                    <td colspan="1">센터명</td>
                                                    <td colspan="2">{{ data.outAsAgentNm }}</td>
                                                    <td colspan="2">고객명</td>
                                                    <td colspan="5"></td>
                                                </tr>
                                                <tr style="background-color: white;">
                                                    <td colspan="1">자재구분</td>
                                                    <td colspan="5" v-if="data.outType === 'BadItem'" style="text-align: center;">
                                                        양품 / <font color="red">불량</font> / 초도불량
                                                    </td>
                                                    <td colspan="5" v-else-if="data.outType === 'UseItem'" style="text-align: center;">
                                                        <font color="red">양품</font> / 불량 / 초도불량
                                                    </td>
                                                    <td colspan="5" v-else style="text-align: center;">
                                                        양품 / 불량 / <font color="red">초도불량</font>
                                                    </td>
                                                    <td colspan="4" style="text-align: center;" v-if="data.processPayYn === 'Y'">
                                                        <font color="red">유상</font> / 무상
                                                    </td>
                                                    <td colspan="4" style="text-align: center;" v-else>
                                                        유상 / <font color="red">무상</font>
                                                    </td>
                                                </tr>
                                                <tr style="background-color: white;">
                                                    <td colspan="1">전산 처리 일자</td>
                                                    <td colspan="9">{{ $moment(data.procDt).format('YYYY-MM-DD HH:mm:ss') }}</td>
                                                </tr>
                                                <tr style="background-color: white;">
                                                    <td colspan="1" height="8">기기의 명칭(모델명)</td>
                                                    <td colspan="9" style="font-size: 6px; ">{{ data.itemNm && data.itemNm.length > 40 ? `${data.itemNm.substring(0, 39)} ...` : data.useModelNm }}</td>
                                                </tr>
                                                <tr style="background-color: white;">
                                                    <td colspan="1">제품 제조번호</td>
                                                    <td colspan="9">{{ data.serialNo }}</td>
                                                </tr>
                                                <tr style="background-color: white;">
                                                    <td colspan="1">사용품번(품목)</td>
                                                    <td colspan="9">{{ data.itemCd }}</td>
                                                </tr>
                                                <tr style="background-color: white;">
                                                    <td colspan="1">회수자재(품목)</td>
                                                    <td colspan="9">{{ data.itemNm }}</td>
                                                </tr>
                                                <tr style="background-color: white;">
                                                    <td colspan="1">사용DPK 일련번호</td>
                                                    <td colspan="9"></td>
                                                </tr>
                                                <tr style="background-color: white;">
                                                    <td height="29" colspan="1">상세불량내역</td>
                                                    <td colspan="9">
                                                        <div style="padding-top:0px;">(사이트명: {{ data.siteNm }})</div>
                                                        <div>{{ data.asFailureCauseDescription }}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                                <tr>
                                    <td>
                                        <hr style="border: dashed 1px #666666"/>
                                    </td>
                                </tr>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
/**
 * * components
 */
 import Layout from '@/components/Slot/ModalSlot.vue';

 export default {
    components: {
        Layout
    },
    props: {
        returnTagInfo: {
            Type: Array,
            required: true
        }
    },
    data() {
        return {
            items: {},
            title: '자재반납TAG 출력'
        }
    },
    methods: {
        tagPrint() {
            var printDiv = document.getElementById("printf");
            var pop = window.open(this.url, '_blank');

            pop.document.write(`<!DOCTYPE html>
                <head>
                    <meta charset="utf-8">
                    <title>LUCOMS 서비스</title>
                </head>
            <body>`);
            pop.document.write(printDiv.innerHTML);
            pop.document.write(`</body>
                <style>
                ${this.printStyle}
                </style>
            </html>`);

            pop.document.close();

            setTimeout(function() {
                pop.print();
                pop.close();
            }, 100);
        },
        /**
         * * 고장원인 상세내용을 가져오기 위한 데이터 재정의 호출
         * * USP_AS_SERVICE_DETAIL_SEL 해당 프로시져를 참조하며, UVW_AS_FAILURE_CAUSE 해당 뷰에서 상세내용을 가져옴..
         * ! 자재반품관리 관련해서는 자재 고장원인에 대한 내용을 포함하고 있는 프로시저 및 뷰가 존재하지 않음. 위와 같은 선택을 하였음.
         * by fixed. jaykim (2023.07.21)
        */
        asFailureCauseDescUpdateData() {
            this.items = this.returnTagInfo.map(x => {
                
                const vForm = {
                    companyId :this.$store.state.loginInfo.compCd,
                    asId: x.srcId2,
                    processTime : ''
                }
                this.$http.post(`/api/workMng/callDispose/aslist`, vForm).then(response => {
                    const {asFailureCauseDescription} = response.data[0];
                    x.asFailureCauseDescription = asFailureCauseDescription;
                })
                return x;
            })
        },
    },
    mounted() {
        //1. 아이템 리스트 고장원인 포함한 데이터 담는 함수 호출
        this.asFailureCauseDescUpdateData();
    },
    
    beforeDestroy() {

    },
    watch: {

    },
    computed: {
        printStyle() {
            return `
            .table-area:nth-child(odd) {
                border-right: dashed 2px #666666;
            }
            
            .table-b {
                width: 100%;
                margin-left: 5px;
                margin-right: 5px;
            }
            
            th, td {
                border: 1px solid black;
                padding: 8px;
            }
            td {
                font-size: 8px;
            }
            .page {
                width: 210mm;
                min-height: 297mm;
                padding: 0mm;
                margin: 0mm auto;
                border: 1px #D3D3D3 solid;
                border-radius: 5px;
                background: white;
                box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
            }
            .subpage {
                padding: 1cm;
                border: 5px red solid;
                height: 257mm;
                outline: 2cm #FFEAEA solid;
            }
            @page {
                size: A4;
                margin: 0;
            }
            @media print {
                table { 
                    // margin-top: 16px;
                }
                .table-area {
                    // width: 50%;
                    display: flex !important;
                    float: left !important;
                }
                // .inner-box {
                //     border-right: dashed 2px #666666;
                // }
                td {
                    font-size: 4px
                }
                html, body {
                    width: 210mm;
                    height: 297mm;
                }
                
            }
            `
        }
    },
    filters: {

    }
 }
</script>